import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';

import ModalFormPage from '../../../../../styledComponents/ModalFormPage/ModalFormPage';

import { SmallModal } from '../../../../../styledComponents/ModalCommon/ModalCommon';
import { withErrorProvider } from '../../../../../hoc/withErrorProvider';
import ResendWelcomeEmailForm from '../../../../../styledComponents/Forms/ResendWelcomeEmailForm/ResendWelcomeEmailForm';
import { RESEND_KE_WELCOME_EMAIL_MODAL_NAME } from './resendKEWelcomeEmailModal.const';
import { useResendKEWelcomeEmailModalForm } from './resendKEWelcomeEmailModal.hooks';

type ResendKEWelcomeEmailModalProps = {
  id?: string;
};

const ResendKEWelcomeEmailModal = ({ id }: ResendKEWelcomeEmailModalProps) => {
  const { t } = useTranslation();
  const {
    submitHandler,
    onCancelHandler,
    welcomeEmailResending,
    initState,
    validateForm,
  } = useResendKEWelcomeEmailModalForm({ id });
  return (
    <SmallModal name={RESEND_KE_WELCOME_EMAIL_MODAL_NAME + id}>
      <Form
        keepDirtyOnReinitialize
        onSubmit={submitHandler}
        initialValues={initState}
        validate={validateForm}
      >
        {({ ...renderProps }) => (
          <ModalFormPage
            mode="small"
            handleSubmit={renderProps.handleSubmit}
            onCancel={onCancelHandler}
            title={t('headers.resend-welcome-email')}
            isProcessing={welcomeEmailResending}
          >
            <ResendWelcomeEmailForm disabled={welcomeEmailResending} />
          </ModalFormPage>
        )}
      </Form>
    </SmallModal>
  );
};

export default withErrorProvider(ResendKEWelcomeEmailModal);
